import type { ReactNode } from "react";
import { Helmet } from "react-helmet-async";

type HeadProps = {
  readonly children?: ReactNode;
};

const Head = ({ children }: HeadProps) => {
  return <Helmet>{children}</Helmet>;
};

export default Head;
